import apiClient from "./apiClient";

export const getLang = () => {
  try { return localStorage.getItem('godea_locale') === 'en' ? 'en' : 'es'; }
  catch (_e) { return 'es'; }
};

/**
 * Config pública (AllowAny) — backend: GET /api/site-config/public/
 * No usar /api/config/: requiere IsAuthenticated y provoca 401 en visitantes.
 */
export const fetchPublicSiteConfig = async () => {
  try {
    const response = await apiClient.get("/site-config/public/", {
      timeoutSet: true,
      timeout: 15000,
      params: { lang: getLang() },
    });
    const data = response.data;
    if (data && Array.isArray(data.results) && data.results.length) {
      return data.results[0];
    }
    return data;
  } catch (e) {
    return null;
  }
};

export const getSiteConfig = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await apiClient.get('/site-config/', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const data = response.data;
    if (data && Array.isArray(data.results) && data.results.length) {
      return data.results[0];
    }
    if (Array.isArray(data) && data.length) {
      return data[0];
    }
    return data;
  } catch (error) {
    console.error('Error fetching site configuration:', error);
    throw error;
  }
};

function resolveSiteConfigId(data) {
  if (!data) return null;
  if (Array.isArray(data.results) && data.results.length > 0) {
    return data.results[0].id;
  }
  if (Array.isArray(data) && data.length > 0) {
    return data[0].id;
  }
  if (data.id != null) {
    return data.id;
  }
  return null;
}

export const updateStorefrontAppearance = async (accentMode) => {
  const token = localStorage.getItem('accessToken');
  const headers = { Authorization: `Bearer ${token}` };
  const response = await apiClient.patch(
    '/site-config/appearance/',
    { storefront_accent_mode: accentMode },
    { headers },
  );
  return response.data;
};

export const updateSiteConfig = async (configData) => {
  try {
    const token = localStorage.getItem('accessToken');
    const headers = { Authorization: `Bearer ${token}` };
    const existingConfig = await apiClient.get('/site-config/', { headers });
    const configId = resolveSiteConfigId(existingConfig.data);

    if (configId != null) {
      const response = await apiClient.patch(`/site-config/${configId}/`, configData, { headers });
      return response.data;
    }

    const response = await apiClient.post('/site-config/', configData, { headers });
    return response.data;
  } catch (error) {
    console.error('Error updating site configuration:', error);
    throw error;
  }
};

export const getSiteConfigFromViewSet = async () => getSiteConfig();

// ── Recomendador de tallas (config global) ─────────────────────────────
// El backend guarda size_recommendation como parte del SiteConfig singleton.

export const getSizeRecommendationConfig = async () => {
  const config = await getSiteConfig();
  return config?.size_recommendation || null;
};

export const saveSizeRecommendationConfig = async (sizeRecommendation) => {
  return updateSiteConfig({ size_recommendation: sizeRecommendation });
};
